export default "__VITE_ASSET__CkZq8edC__"